'use client';

import { c as _c } from "react/compiler-runtime";
import { Chip } from '@common/components';
import useEmblaCarousel from 'embla-carousel-react';
import { useCustomRouter } from '@/hooks/useCustomRouter';
export enum CATEGORY_LIST_KEY {
  POLICY = 'POLICY',
  EMERGENCY = 'EMERGENCY',
  HOMETOWN_NEWS = 'HOMETOWN_NEWS',
  WELLO_NEWS = 'WELLO_NEWS',
  POLICY_INFO = 'POLICY_INFO',
  FESTIVAL = 'FESTIVAL',
}
const CATEGORY_LIST = [{
  key: CATEGORY_LIST_KEY.POLICY,
  name: '정책'
}, {
  key: CATEGORY_LIST_KEY.EMERGENCY,
  name: '응급생활'
}, {
  key: CATEGORY_LIST_KEY.POLICY_INFO,
  name: '정책소식'
}, {
  key: CATEGORY_LIST_KEY.HOMETOWN_NEWS,
  name: '동네소식'
}, {
  key: CATEGORY_LIST_KEY.WELLO_NEWS,
  name: '웰로소식'
}, {
  key: CATEGORY_LIST_KEY.FESTIVAL,
  name: '동네축제'
}];
export const QUERY_STRING_KEY_MY_INFO_SCRAP_CATEGORY = 'category';
interface CategorySwiperProps {
  selectedCategory: `${CATEGORY_LIST_KEY}`;
}
export const CategorySwiper = t0 => {
  const $ = _c(9);
  const {
    selectedCategory
  } = t0;
  const router = useCustomRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef] = useEmblaCarousel(t1);
  let t2;
  if ($[1] !== router || $[2] !== selectedCategory) {
    t2 = CATEGORY_LIST.map(categoryListItem => <div key={categoryListItem.key} className="w-fit flex-[0_0_auto] last:mr-20"><Chip checked={categoryListItem.key === selectedCategory} className="flex h-34 select-none items-center typo-body4" theme="primary" onClick={() => router.replace(`?${QUERY_STRING_KEY_MY_INFO_SCRAP_CATEGORY}=${categoryListItem.key}`)}>{categoryListItem.name}</Chip></div>);
    $[1] = router;
    $[2] = selectedCategory;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex gap-6">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== emblaRef || $[7] !== t3) {
    t4 = <div className="scrollbar-hide w-full overflow-x-scroll py-20 pl-20" ref={emblaRef}>{t3}</div>;
    $[6] = emblaRef;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};